import { createClient } from '@supabase/supabase-js';

function validateSupabaseUrl(url: string): string {
  try {
    // Test if it's a valid URL
    new URL(url);
    return url;
  } catch {
    // Return a valid but non-functional URL to prevent runtime errors
    return 'https://placeholder-url.supabase.co';
  }
}

// Initialize with empty values to prevent runtime errors
const supabaseUrl = validateSupabaseUrl(import.meta.env.VITE_SUPABASE_URL || '');
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Helper function to check if Supabase is properly configured
export function isSupabaseConfigured(): boolean {
  try {
    const url = new URL(import.meta.env.VITE_SUPABASE_URL || '');
    return Boolean(
      url.hostname.includes('supabase') && 
      import.meta.env.VITE_SUPABASE_ANON_KEY
    );
  } catch {
    return false;
  }
}